module.exports = __webpack_public_path__ + "media/pdfs/Prepworks-Mentorship-Flyer-2021-d66654400775821e127851f12fd1af0a.pdf";